import React from "react";
import "./index.scss"
import { Badge } from "@mui/material";

const CustomBadge = ({ children, badgeContent, ...rest }) => {
  return (
    <div className="styled-badge">
      <Badge badgeContent={badgeContent} {...rest}>
        {children}
      </Badge>
    </div>
  )
};

export default CustomBadge;
